"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PoliciesClient = void 0;
const fetch_1 = require("../../utils/fetch");
const url_1 = require("../../utils/url");
class PoliciesClient {
    constructor(apiOptions) {
        this.apiOptions = apiOptions;
    }
    async archivePolicy(request) {
        const path = (0, url_1.buildPathAndQuery)('/v2/policies/:policyId', {
            path: request ?? {},
            query: {},
        });
        const response = await (0, fetch_1.userActionFetch)(path, {
            method: 'DELETE',
            body: {},
            apiOptions: this.apiOptions,
        });
        return response.json();
    }
    async createApprovalDecision(request) {
        const path = (0, url_1.buildPathAndQuery)('/v2/policy-approvals/:approvalId/decisions', {
            path: request ?? {},
            query: {},
        });
        const response = await (0, fetch_1.userActionFetch)(path, {
            method: 'POST',
            body: request.body,
            apiOptions: this.apiOptions,
        });
        return response.json();
    }
    async createPolicy(request) {
        const path = (0, url_1.buildPathAndQuery)('/v2/policies', {
            path: request ?? {},
            query: {},
        });
        const response = await (0, fetch_1.userActionFetch)(path, {
            method: 'POST',
            body: request.body,
            apiOptions: this.apiOptions,
        });
        return response.json();
    }
    async getPolicy(request) {
        const path = (0, url_1.buildPathAndQuery)('/v2/policies/:policyId', {
            path: request ?? {},
            query: {},
        });
        const response = await (0, fetch_1.simpleFetch)(path, {
            method: 'GET',
            apiOptions: this.apiOptions,
        });
        return response.json();
    }
    async listApprovals(request) {
        const path = (0, url_1.buildPathAndQuery)('/v2/policy-approvals', {
            path: request ?? {},
            query: request?.query ?? {},
        });
        const response = await (0, fetch_1.simpleFetch)(path, {
            method: 'GET',
            apiOptions: this.apiOptions,
        });
        return response.json();
    }
    async listPolicies(request) {
        const path = (0, url_1.buildPathAndQuery)('/v2/policies', {
            path: request ?? {},
            query: request?.query ?? {},
        });
        const response = await (0, fetch_1.simpleFetch)(path, {
            method: 'GET',
            apiOptions: this.apiOptions,
        });
        return response.json();
    }
    async updatePolicy(request) {
        const path = (0, url_1.buildPathAndQuery)('/v2/policies/:policyId', {
            path: request ?? {},
            query: {},
        });
        const response = await (0, fetch_1.userActionFetch)(path, {
            method: 'PUT',
            body: request.body,
            apiOptions: this.apiOptions,
        });
        return response.json();
    }
}
exports.PoliciesClient = PoliciesClient;
